import { IElement } from "core-integration/src/store/elements/types";
import { size } from "polished";
import React from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import {
  ArrowEnd,
  ArrowEndDouble,
  ArrowStart,
  ArrowStartDouble,
} from "../icons/Arrows";
import PaginatorButton from "../paginator/PaginatorButton";

export const PaginatorArrowIconStart = styled(ArrowStart)`
  ${size(12, 14)}
`;

const PaginatorArrowIconEnd = styled(ArrowEnd)`
  ${size(12, 14)}
`;

const PaginatorIconStartDouble = styled(ArrowStartDouble)`
  ${size(8, 16)}
`;
const PaginatorIconEndDouble = styled(ArrowEndDouble)`
  ${size(8, 16)}
`;

export const paginate = (
  elements: IElement[],
  page: number,
  pageSize: number,
) => {
  const start = (page - 1) * pageSize;
  return {
    data: elements.slice(start, start + pageSize),
    totalPages: Math.ceil(elements.length / pageSize),
  };
};

interface IProps {
  page: number;
  setPage: (page: number) => void;
  totalPages: number;
}

const Paginator: React.FunctionComponent<IProps> = ({
  page,
  setPage,
  totalPages,
}) => {
  const { t } = useTranslation();
  return (
    <Flex justifyContent="space-between" alignItems="center" p={2}>
      <PaginatorButton
        actionMe={() => setPage(1)}
        label={t("paginator.first", "First")}
        disabled={page === 1}
        isSmall={true}
      >
        <PaginatorIconStartDouble />
      </PaginatorButton>
      <PaginatorButton
        actionMe={() => setPage(page - 1)}
        label={t("paginator.previous", "Previous")}
        disabled={page === 1}
      >
        <PaginatorArrowIconStart />
      </PaginatorButton>
      <div>
        {/* <Trans
          i18nKey="paginator.pageOf"
          values={{ page, totalPages }}
          defaults="<0>{{page}}</0> of {{totalPages}}"
          components={[<strong />]}
        />*/}
      </div>
      <PaginatorButton
        actionMe={() => setPage(page + 1)}
        label={t("paginator.next", "Next")}
        disabled={page === totalPages}
      >
        <PaginatorArrowIconEnd />
      </PaginatorButton>
      <PaginatorButton
        actionMe={() => setPage(totalPages)}
        label={t("paginator.last", "Last")}
        disabled={page === totalPages}
        isSmall={true}
      >
        <PaginatorIconEndDouble />
      </PaginatorButton>
    </Flex>
  );
};

export default Paginator;
